<template>
  <validation-observer ref="formAddPerformance" #default="{ invalid }">
    <b-form @submit.prevent="formSubmitted">
      <b-row>
        <b-col md="12">
          <b-form-group label="Reward Title" label-for="awardTitle">
            <validation-provider
              rules="required"
              #default="{ errors }"
              name="Reward Title"
              vid="awardTitle"
            >
              <b-form-input
                name="awardTitle"
                placeholder="Reward Title"
                v-model="performanceRecord.awardTitle"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col sm="12">
          <b-form-group label="Employee" label-for="employeeId">
            <validation-provider
              rules="required"
              #default="{ errors }"
              name="Employee"
              vid="employee"
            >
              <b-form-select
                id="employeeId"
                v-model="performanceRecord.employeeId"
                :options="employeeOptions"
                value-field="id"
                text-field="employeeFullName"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col md="12">
          <b-form-group label="Price" label-for="price">
            <b-form-input
              name="price"
              placeholder="Price"
              v-model="performanceRecord.price"
              type="number"
            />
          </b-form-group>
        </b-col>

        <b-col md="12">
          <b-form-group label="Gift" label-for="gift">
            <b-form-input
              name="gift"
              placeholder="Gift"
              v-model="performanceRecord.gift"
            />
          </b-form-group>
        </b-col>

        <b-col sm="12">
          <b-form-group label="Date" label-for="date">
            <validation-provider
              rules="required"
              #default="{ errors }"
              name="Date"
              vid="date"
            >
              <b-form-datepicker
                id="date"
                placeholder="Date"
                v-model="performanceRecord.date"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col md="12">
          <b-form-group>
            <b-form-checkbox v-model="performanceRecord.addPayroll">
              Add on Payroll
            </b-form-checkbox>
          </b-form-group>
        </b-col>

        <b-col md="12" v-if="performanceRecord.addPayroll">
          <validation-provider
            rules="required"
            #default="{ errors }"
            name="Payroll Month"
            vid="payrollMonth"
          >
            <b-form-group label="Select Month" label-for="selectMonth">
              <b-form-select
                id="selectMonth"
                :options="monthOptions"
                v-model="performanceRecord.payrollMonth"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>

        <b-col md="12" class="d-flex justify-content-end">
          <b-button type="submit" variant="primary" class="mr-2">
            Save
            <b-spinner v-if="loading" class="mx-2"></b-spinner>
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </validation-observer>
</template>

<script>
import {
  BRow,
  BCol,
  BForm,
  BFormInput,
  BFormGroup,
  BButton,
  BSpinner,
  BFormSelect,
  BFormDatepicker,
  BFormCheckbox,
} from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";

// Function to get last 12 months for the select options
function getLast12Months() {
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const today = new Date();
  let last12Months = [];

  for (let i = 0; i < 12; i++) {
    let date = new Date();
    date.setMonth(today.getMonth() - i);
    let year = date.getFullYear();
    let monthIndex = date.getMonth();
    last12Months.push({
      value: `${year}-${String(monthIndex + 1).padStart(2, '0')}`,
      text: `${months[monthIndex]} ${year}`
    });
  }

  return last12Months;
}


export default {
  name: "AddPerformance",
  components: {
    BRow,
    BCol,
    BForm,
    BFormInput,
    BFormGroup,
    BButton,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
    BFormSelect,
    BFormDatepicker,
    BFormCheckbox,
  },
  data() {
    return {
      performanceRecord: {
        awardTitle: "",
        employeeId: "",
        price: null,
        gift: "",
        date: "",
        payrollMonth: "", 
        addPayroll: false,  
      },
      monthOptions: getLast12Months(), 
    };
  },
  computed: {
    ...mapGetters("employeeModule", {
      employeeOptionsRaw: "employees",
      loading: "loading",
    }),
    employeeOptions() {
      return this.employeeOptionsRaw.map((employee) => ({
        id: employee.id,
        employeeFullName: `${employee.firstName} ${employee.lastName}`,
      }));
    },
  },
  methods: {
    ...mapActions("employeeModule", ["getEmployeeListAction"]),
    ...mapActions("performancerecordModule", [
      "getPerformanceRecordListAction",
      "addPerformanceRecordAction",
    ]),

    formSubmitted() {
  
  if (this.performanceRecord.addPayroll && !this.performanceRecord.payrollMonth) {
    this.$swal("Error!", "Payroll Month is required when Add on Payroll is checked.", "error");
    return; 
  }

  
  if (!this.performanceRecord.addPayroll) {
    this.performanceRecord.payrollMonth = null;
  } else if (this.performanceRecord.payrollMonth) {

    const month = this.performanceRecord.payrollMonth;
   
    const formattedDate = new Date(`${month}-01T00:00:00Z`).toISOString();
    this.performanceRecord.payrollMonth = formattedDate;
  }


  this.$refs.formAddPerformance.validate().then((success) => {
    if (success) {
      this.loading = true;
      let loader = this.$swal({
        title: "Processing...",
        text: "Please wait while the Performance is being added",
        onOpen: () => {
          this.$swal.showLoading();
        },
        allowOutsideClick: () => !this.$swal.isLoading(),
        buttonsStyling: false,
        showConfirmButton: false,
      });

      // Submit the performance record data
      this.addPerformanceRecordAction(this.performanceRecord)
        .then(() => {
          loader.close();
          this.success();
          this.$bvModal.hide("modal-add-performance");
          this.loading = false;
          this.getPerformanceRecordListAction();
        })
        .catch((error) => {
          loader.close();
          this.error(error.response.data);
          this.loading = false;
          this.getPerformanceRecordListAction();
        });
    }
  });
},


    success() {
      this.$swal({
        title: "Performance added!",
        text: "You have successfully added the Performance!",
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$emit("PerformanceAdded");
        }
      });
    },

    error(data) {
      this.$swal("Error!", this.getErrorString(data) || "Failed!", "error");
    },

    getErrorString(data) {
      let msg = "<div><p>Cannot post your request due to the following errors:</p>";
      if (data.errors) {
        for (let prop in data.errors) {
          msg += `<p>${prop.replace("$.", "")}: ${data.errors[prop]
            .toString()
            .replace("$.", "")}</p>`;
        }
      } else if (data.message) {
        msg += `<p>${data.message}</p>`;
      }
      return msg + "</div>";
    },
  },
};
</script>
